












































































import { Component, Prop, Vue } from 'vue-property-decorator';
// import ContactForm from '@/components/ContactForm.vue';
import { HOST, API_URL } from '@/global';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import axios from 'axios';

const DEFAULT_FORM_DATA: any = {
  full_name: '',
  email: '',
  phone: '',
  message: ''
};

@Component({
  name: 'ContactUs',
  components: {
    ValidationProvider,
    ValidationObserver
  }
})
export default class ContactUs extends Vue {
  @Prop() compData: any;
  HOST: string = HOST;
  submitted = false;
  submitSuccess = false;

  contactForm: any = JSON.parse(JSON.stringify(DEFAULT_FORM_DATA));
  $refs!: {
    form: InstanceType<typeof ValidationObserver>;
  };

  onSubmit() {
    console.log('clicked!');
    this.$refs.form
      .validate()
      .then(success => {
        if (!success) {
          return;
        }

        axios
          .post(`${API_URL}/contact-form/`, this.contactForm)
          .then(({ data: any }) => {
            this.contactForm = JSON.parse(JSON.stringify(DEFAULT_FORM_DATA));
            this.$nextTick(() => {
              this.$refs.form.reset();
              this.submitted = true;
              this.submitSuccess = true;
            });
          })
          .catch((e: any) => {
            console.log(e);
            this.submitted = true;
          });

        // Resetting Values

        // Wait until the models are updated in the UI
      })
      .catch((e: any) => {
        console.log(e);
      });
  }
}
